import React, {Component} from 'react';
import {Checkbox, Input, Modal} from "antd";
import "./ImagesGallery.scss"
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";

const {Search} = Input;
const seekSpider = {
    // 搜索配置项
    findPictureKey: 'findPictureFtitle',//图片保存标题key
    findPicturePlaceholder: '请输入图片搜索内容',//图片的提示
};

export default class ImagesGallery extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            seekSpiderInformation: {
                findPicture: '',//输入搜索内容
            },
            url: {
                getPersonOrDeptUrl: "/search-server/search/getList/picture/personOrDept",//我的部门图片库
                getPersonUrl: "/search-server/search/getList/picture/person",//我的图片库
            },
            params: {
                "pageNum": 1,
                "pageSize": 9999,
                "keyword": ""
            },//图片库查询字段
            zykPicList: [],//图片库
            onlyMyPics: false,
            total: 0,
            checkedList: [],// 多张图片
            check: false,
            picVisible: false,
            currentPic:""
        };
    }

    componentDidMount() {
        this.getZykPicList();
    }

    render() {
        const {seekSpiderInformation, zykPicList, total, checkedList} = this.state;

        return (
            <div className="imagesGallery">
                <div className="freeNude">
                    <Search
                        className="searchInput"
                        allowClear={true}
                        placeholder={seekSpider.findPicturePlaceholder}
                        onSearch={(value) => {
                            this.picOnSearch(value)
                        }}
                        onChange={(e) => {
                            this.setData('findPicture', e.target.value)
                        }}
                        value={seekSpiderInformation.findPicture}
                    />
                    <div onClick={() => {
                        this.checkInfor()
                    }}>
                        {/*验证*/}
                    </div>
                    <div onClick={() => {
                        this.setInformation({
                            findPictureFtitle: '作者',
                        })
                    }}>
                        {/*设置内容*/}
                    </div>
                    <div className="resource">
                        <Checkbox onChange={(e) => {
                            this.state.onlyMyPics = e.target.checked;
                            this.getZykPicList()
                        }}>仅我的资源</Checkbox>
                        <div className="record">
                            共<span style={{color: '#0050B3'}}> {total} </span>条记录
                        </div>
                        <div>已选(<span style={{color: '#0050B3'}}> {checkedList.length} </span>)</div>
                    </div>
                </div>
                <Scrollbars autoHeight autoHeightMax={'350px'}>
                    <div className="outermost" style={{width: '950px'}}>
                        {
                            zykPicList && zykPicList.map((item, index) => {
                                return (
                                    <div className="fromStream" style={{borderColor: item.checked ? '#0050B3' : ""}}
                                         key={item.id} onClick={() => {
                                        this.picsAll(item)
                                    }}>
                                        <img className="repository" src={item.smallPath}/>
                                        <div className="rightWords">
                                            <div className="headline">{item.name}</div>
                                            <div className="uploadData">
                                                <div>来源：{item.source}</div>
                                                <div>日期：{moment(item.createTime).format('yyyy-MM-DD HH:mm:ss')}</div>
                                                <div>大小：{item.width}*{item.height}</div>
                                            </div>
                                            <div className="preview">
                                                <div onClick={()=>{
                                                    this.showModal(item)
                                                }}>预览</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </Scrollbars>
                {this.renderModal()}
            </div>
        )
    }

    //获取部门图片库
    getZykPicList = (value) => {
        let params = {
            ...this.state.params,
            keyword: value,
        };
        let config = this.state.onlyMyPics ? 'getPersonUrl' : 'getPersonOrDeptUrl';
        let url = this.state.url[config];
        this.request({
            url,
            body: params,
            method: "post",
            contentType: 'json',
            callBack: (res) => {
                let zykPicList = [];
                let total = 0;
                if (res && res.data) {
                    zykPicList = res.data;
                    total = res.count;
                }
                this.setState({zykPicList, total});
                // console.log(res)
            }
        })
    };
    // 预览图片
    renderModal=()=>{
        return (
            <Modal
                visible={this.state.picVisible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width={900}
                footer={null}
                bodyStyle={{textAlign:'center'}}
            >
               <img src={this.state.currentPic} width={800}/>
            </Modal>
        )
    };
    //搜索
    picOnSearch = (value) => {
        this.getZykPicList(value)
    };
    // 选择多张图片上传
    picsAll = (zykPic) => {
        let {zykPicList} = this.state;
        let index = zykPicList.findIndex(item => item.id == zykPic.id);
        zykPicList[index].checked = !zykPic.checked;
        this.setState({});
        if (typeof this.props.onChange == 'function') {
            let checkedList = zykPicList.filter(item => item.checked);
            this.setState({checkedList})
        }
        this.props.onChange(this.state.checkedList);
    };

    //输入框改变复制
    setData(key, val) {
        // console.log(key, val);
        this.state.seekSpiderInformation[key] = val;
        this.setState({
            params: {
                ...this.state.params,
                keyword: val
            }
        });
        if (!val) {
            this.getZykPicList(val)
        }
    }

    showModal = (item) => {
        // console.log(item);
        this.setState({
            picVisible: true,
            currentPic:item.smallPath
        });
    };

    handleOk = e => {
        // console.log(e);
        this.setState({
            picVisible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            picVisible: false,
        });
    };
    //获取信息
    getInformation() {
        let seekSpiderData = {};
        const {seekSpiderInformation} = this.state;
        seekSpiderData[seekSpider.findPictureKey] = seekSpiderInformation.findPicture;//获取图片
        return seekSpiderData
    }

    //设置默认数据
    setInformation(seekSpiderData = {}) {
        // console.log(seekSpiderData);
        this.state.seekSpiderInformation['findPicture'] = seekSpiderData[seekSpider.findPictureKey] || '';//设置图片
        this.setState({})
    }

    checkInfor() {
        console.log(this.getInformation())
    }
}